import styled from 'styled-components';

const baseWrap = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.8rem;
`;

export const FullPageWrap = styled.div`
  ${baseWrap}
  min-height: 100vh;
  padding: ${({ theme }) => theme.spacing.xxl};
  gap: ${({ theme }) => theme.spacing.md};
`;

export const InlineWrap = styled.div`
  ${baseWrap}
  padding: ${({ theme }) => `${theme.spacing.xxl} ${theme.spacing.lg}`};
  gap: ${({ theme }) => theme.spacing.md};
  border-radius: 1.6rem;
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem dashed ${({ theme }) => theme.colors.border};
`;

export const CompactWrap = styled.div`
  ${baseWrap}
  padding: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.md}`};
`;

export const Icon = styled.div`
  font-size: 3.6rem;
  line-height: 1;
`;

export const Title = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const Body = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
  max-width: 36rem;
  margin: 0;
`;

export const ActionButton = styled.button`
  margin-top: ${({ theme }) => theme.spacing.sm};
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 1rem;
  padding: 1rem 2rem;
  font-size: 1.4rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s ease;

  &:hover {
    transform: translateY(-0.1rem);
  }
`;
